        
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->

<div class="user-box" style="display: flex; align-items: center;">
    <div class="span-container" style="text-align: right; color: #0661b3;">
      <span class="top-span">¡Hola {{logUserName}}!</span>

      <div *ngIf="!visibleArrow">
        <span class="bottom-span">{{selectedPerfil.nombrePerfil}}</span>
      </div>

      <div *ngIf="visibleArrow">
        <span (click)="toggleDropdown($event)" class="bottom-span" style="cursor: pointer;">{{ selectedPerfil.nombrePerfil }} <mat-icon style="cursor: pointer;">{{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}} </mat-icon></span>
        <div *ngIf="isOpen" class="custom-dropdown">
          <div *ngFor="let perfil of perfiles" (click)="selectPerfil(perfil)" class="dropdown-item">
            {{ perfil.nombrePerfil }}
            <mat-icon *ngIf="selectedPerfil.nombrePerfil === perfil.nombrePerfil">check</mat-icon>
          </div>
        </div>
      </div>

      <span class="bottom-span">{{direccionRegional}}</span>
      <span class="bottom-span">{{unidad}}</span>
    </div>
  <app-secondary-button (click)="logOut()" buttonText="Cerrar sesión" buttonClass="btn btn-secondary" />
</div>